__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "freya-artwork-mgmt-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(5120), __webpack_require__.e(1519), __webpack_require__.e(4001)]).then(() => (() => (__webpack_require__(4001))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(3575), __webpack_require__.e(1519), __webpack_require__.e(6302)]).then(() => (() => (__webpack_require__(76302))))));
			register("@mui/material", "0", () => (Promise.all([__webpack_require__.e(6772), __webpack_require__.e(3714), __webpack_require__.e(229), __webpack_require__.e(5955), __webpack_require__.e(6083), __webpack_require__.e(563), __webpack_require__.e(5120), __webpack_require__.e(5889), __webpack_require__.e(408), __webpack_require__.e(3575), __webpack_require__.e(3712), __webpack_require__.e(6769), __webpack_require__.e(5142), __webpack_require__.e(1519)]).then(() => (() => (__webpack_require__(90408))))));
			register("notistack", "3.0.2", () => (Promise.all([__webpack_require__.e(1036), __webpack_require__.e(5142), __webpack_require__.e(1519)]).then(() => (() => (__webpack_require__(91036))))));
			register("react-dom", "19.2.6", () => (Promise.all([__webpack_require__.e(1519), __webpack_require__.e(1473)]).then(() => (() => (__webpack_require__(61473))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(2921), __webpack_require__.e(5142), __webpack_require__.e(1519)]).then(() => (() => (__webpack_require__(52921))))));
			register("react/jsx-dev-runtime", "19.2.6", () => (__webpack_require__.e(6895).then(() => (() => (__webpack_require__(56895))))));
			register("react/jsx-runtime", "19.2.6", () => (__webpack_require__.e(4301).then(() => (() => (__webpack_require__(54301))))));
			register("react", "19.2.6", () => (__webpack_require__.e(4521).then(() => (() => (__webpack_require__(64521))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};